export default __webpack_public_path__ + "static/media/shikma2.9ee59499.jpg";